(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (section) => {
    if (!section || section.dataset.theiaEditorialReady === 'true') return;
    section.dataset.theiaEditorialReady = 'true';

    const items = [...section.querySelectorAll('[data-theia-editorial-reveal]')];
    if (!items.length || reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    section.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-theia-editorial-collage]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
